import { ActionButton, Buttons, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import React from 'react';

function LoadPaymentFromQuickBooksDialog({ payment, resolve }) {
  const { workspace } = useWorkspace();
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const handleSubmit = async () => {
    form.submit();

    try {
      await api.www.workspaces(workspace.id).clientPayments(payment.id).loadFromQuickBooks();
      await resolve();
      toast.success('The payment has been reloaded from QuickBooks.');
    } catch (error) {
      toast.error(error.message ?? 'An error has occurred. The payment has not been reloaded from QuickBooks.');
      form.done();
    }
  };

  return (
    <ModalCard title="Reload from QuickBooks" onClose={() => resolve(false)}>
      <ModalCard.Body>Are you sure you want to reload this payment from QuickBooks?</ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
            Reload
          </ActionButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default LoadPaymentFromQuickBooksDialog;
